import React from "react";
import "./style.scss";

export default function PwaInstructionCard({
  image,
  text,
  className,
  topSpace,
  bottomSpace,
  leftSpace,
  rightSpace,
  noImage = false,
}) {
  const clsScreen = ["pwa-card__screen"];
  if (className) clsScreen.push(className);
  if (topSpace) clsScreen.push("pwa-card__screen--top-space");
  if (bottomSpace) clsScreen.push("pwa-card__screen--bottom-space");
  if (leftSpace) clsScreen.push("pwa-card__screen--left-space");
  if (rightSpace) clsScreen.push("pwa-card__screen--right-space");

  return (
    <>
      <div className="pwa-card">
        {!noImage && (
          <div className={clsScreen.join(" ")}>
            <img src={image} alt="" />
          </div>
        )}
        <div className="pwa-card__text">{text}</div>
      </div>
    </>
  );
}
